import { Controller } from '@hotwired/stimulus'

// Client-side filter for the kiosk employee grid: as the cashier types, hide
// tiles whose name doesn't match. Pure show/hide (no network) so it stays
// instant on a low-end kiosk tablet. Each tile carries its lowercased name in
// `data-name`; the empty-state shows when nothing matches.
export class KioskFilterController extends Controller {
  static targets = ['query', 'tile', 'empty']

  filter () {
    const term = this.queryTarget.value.trim().toLowerCase()
    let visible = 0

    this.tileTargets.forEach((tile) => {
      const match = tile.dataset.name.includes(term)
      tile.classList.toggle('hidden', !match)
      if (match) visible += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle('hidden', visible > 0)
  }
}
